import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  TextField,
  Divider
} from '@mui/material';

const IntegrationSection = ({ projectId, data, onChange }) => {
  const [formData, setFormData] = useState(data || {});
  
  // Update parent component when local state changes
  useEffect(() => {
    onChange(formData);
  }, [formData, onChange]);
  
  // Handle text field changes
  const handleTextChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value
    });
  };
  
  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Section Name
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Section description goes here.
      </Typography>
      
      <Divider sx={{ my: 3 }} />
      
      {/* Form fields will go here */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" gutterBottom>
          Field Label
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          placeholder="Placeholder text"
          value={formData.fieldName || ''}
          onChange={handleTextChange('fieldName')}
        />
      </Box>
    </Box>
  );
};

export default IntegrationSection;